import { render, staticRenderFns } from "./HeaderWishlist.vue?vue&type=template&id=3887bbc9&scoped=true&"
import script from "./HeaderWishlist.vue?vue&type=script&lang=ts&"
export * from "./HeaderWishlist.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderWishlist.vue?vue&type=style&index=0&id=3887bbc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887bbc9",
  null
  
)

export default component.exports